/* import __COLOCATED_TEMPLATE__ from './email-collector-reply.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();